import { twMerge } from 'tailwind-merge';

interface NavigationDotProps {
  active?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
}

export const NavigationDot = ({
  active,
  disabled,
  className,
  onClick,
}: NavigationDotProps) => {
  return (
    <div
      className={twMerge(
        'w-[7.5px] min-w-[7.5px] h-[7.5px] min-h-[7.5px] bg-purple-9D8AFF/75 rounded-full hover:cursor-pointer',
        active && 'bg-white',
        className
      )}
      onClick={disabled ? () => {} : onClick}
    />
  );
};
